import { render } from "./WildBookEntryAnimalExtension.vue?vue&type=template&id=37a914c1&scoped=true&ts=true"
import script from "./WildBookEntryAnimalExtension.vue?vue&type=script&lang=ts"
export * from "./WildBookEntryAnimalExtension.vue?vue&type=script&lang=ts"

import "./WildBookEntryAnimalExtension.vue?vue&type=style&index=0&id=37a914c1&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a914c1"]])

export default __exports__